import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {MatchEventsModuleState} from "./models/match-events-module.state";
import {MatchEventsModuleConfig} from "./match-events.module-config";

export class MatchEventsModuleStore extends BaseMobxStore {
  state: MatchEventsModuleState;

  static injectables = [MatchEventsModuleConfig, MatchEventsModuleState];

  selectMatchEventTabByIndex(index: Number){
    this.state.selectedTabIndex = index;
  }
}
